import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "amenity-modal",
  class: "embinfobox elem-modal basic",
  ref: "baseElement"
}
const _hoisted_2 = {
  "aria-label": "card",
  class: "map-card"
}
const _hoisted_3 = { class: "emb-card_body" }
const _hoisted_4 = { class: "mb-10" }
const _hoisted_5 = {
  key: 0,
  class: "ammenity-title"
}
const _hoisted_6 = {
  key: 0,
  class: "tab"
}
const _hoisted_7 = { class: "tab-slider" }
const _hoisted_8 = {
  key: 0,
  class: "ammenity-imginfo"
}
const _hoisted_9 = {
  key: 0,
  class: "carousel-navigation"
}
const _hoisted_10 = {
  key: 1,
  class: "content-bottom"
}
const _hoisted_11 = {
  key: 0,
  class: "ammenity-next"
}
const _hoisted_12 = { class: "ammenity-next-link" }
const _hoisted_13 = { class: "ammenity-next-icon" }

import { ref, onMounted, toRefs } from "vue";
import LazyImage from "./../LazyImage.vue";
import LeftArrowIcon from "@/assets/icons/LeftArrow.vue";
import { AmenityInfo, Amenity } from "./../../types";
import { addImageScaler } from "./../../core";
import { Carousel, Navigation, Slide } from "vue3-carousel";



export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapAmenityInfoWindow',
  props: {
    amenityInfo: {},
    amenityId: {},
    uniqueAmenity: {},
    isKioskMode: { type: Boolean },
    amenities: {},
    loadNewAmenity: { type: Function }
  },
  setup(__props: any) {

const props = __props;


const {
  amenityInfo,
  amenityId,
  uniqueAmenity,
  isKioskMode,
  amenities,
  loadNewAmenity,
} = toRefs(props);



const sliderOptions = ref({ itemsToShow: 1 });
const amenityTitle = ref("");
const amenityCaption = ref("");
const nextAmenityName = ref("");

function setNextAmenityName() {
  let currentIndex = uniqueAmenity.value.indexOf(amenityId.value);
  const nextIndex = (currentIndex + 1) % uniqueAmenity.value.length;
  const uniqueAmenityId = uniqueAmenity.value[nextIndex];
  const nextAminity = amenities.value.find((x) => x.id === uniqueAmenityId);
  nextAmenityName.value = nextAminity ? nextAminity.title : "";
}

function setAmenityTitleAndCaption() {
  for (const info of amenityInfo.value) {
    if (!amenityTitle.value && info.title) amenityTitle.value = info.title;
    if (!amenityCaption.value && info.caption) amenityCaption.value = info.caption;
  }
}

function addScaler(url: string) {
  return addImageScaler(url);
}

onMounted(() => {
  setAmenityTitleAndCaption();
  setNextAmenityName();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("i", {
        "aria-label": "close icon",
        class: "emb_closeicon"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (amenityTitle.value)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(amenityTitle.value), 1))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "ammenity-site-address" }, "Community feature", -1))
        ]),
        _createElementVNode("div", null, [
          (!!_unref(amenityInfo).length &&
            !_unref(amenityInfo).every((info) => !info.image_url)
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(Carousel), _mergeProps({ ref: "slick" }, sliderOptions.value), {
                    addons: _withCtx(() => [
                      (_unref(amenityInfo).length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_unref(Navigation))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(amenityInfo), (amenityInfoImage) => {
                        return (_openBlock(), _createBlock(_unref(Slide), {
                          key: amenityInfoImage.seq_position
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(LazyImage, {
                                src: addScaler(amenityInfoImage.image_url),
                                alt: amenityInfoImage.caption,
                                isNeighborhoodImage: false
                              }, null, 8, ["src", "alt"]),
                              (amenityInfoImage.caption)
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(amenityInfoImage.caption), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 16)
                ])
              ]))
            : (amenityCaption.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(amenityCaption.value), 1))
              : _createCommentVNode("", true)
        ]),
        (_unref(uniqueAmenity)?.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(loadNewAmenity)()))
              }, [
                _cache[2] || (_cache[2] = _createTextVNode(" Next feature: ", -1)),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(nextAmenityName.value) + " ", 1),
                  _createElementVNode("i", _hoisted_13, [
                    _createVNode(LeftArrowIcon, { class: "rotate-180" })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}
}

})